module.exports = __webpack_public_path__ + "img/5-800x800.176e3ecd.png";